import { X, Check } from "lucide-react";

const RTEXT = { common: "text-zinc-300", uncommon: "text-emerald-300", rare: "text-sky-300", epic: "text-fuchsia-300", legendary: "text-amber-300", goddess: "text-rose-300" };

// Collapsed "you picked this card" panel — mirrors the Adventure picker. Shows only
// the chosen card with its key stats and a clear way to choose another.
export function SelectedCardBar({ card, onClear, testid = "selected-card", accent = "amber" }) {
  if (!card) return null;
  const a = card.arena || {};
  return (
    <div data-testid={testid} className="rounded-2xl border border-amber-400/40 bg-amber-400/[0.05] p-4 flex items-center gap-4">
      <button onClick={onClear} data-testid={`${testid}-clear`}
        className="relative w-20 shrink-0 rounded-lg overflow-hidden ring-2 ring-amber-300/60 group">
        {card.front_image && <img src={card.front_image} alt={card.title} className="w-full aspect-[3/4] object-cover" />}
        <span className="absolute inset-0 group-hover:bg-black/45 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
          <X className="h-5 w-5 text-white" />
        </span>
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <Check className="h-4 w-4 text-amber-300 shrink-0" />
          <span className="text-white font-medium truncate">{card.title}</span>
          <span className={`text-[10px] font-mono uppercase ${RTEXT[card.rarity] || "text-zinc-300"}`}>{card.rarity}</span>
        </div>
        <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1 font-mono text-[11px] text-white/65">
          <span>ATK {a.atk ?? "—"}</span><span>DEF {a.def ?? "—"}</span><span>SPD {a.spd ?? "—"}</span><span>HP {a.hp ?? "—"}</span>
        </div>
        <button onClick={onClear} className="mt-1.5 inline-flex items-center gap-1 text-[11px] text-amber-300/90 hover:text-amber-200">
          <X className="h-3 w-3" /> Choose another card
        </button>
      </div>
    </div>
  );
}
